import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
// biome-ignore lint/performance/noNamespaceImport: Part of Sentry initialization
import * as Sentry from "@sentry/react";
import {
  type TypedUseSelectorHook,
  useDispatch,
  useSelector,
} from "react-redux";
import easiRechargeReducer from "@/redux/slices/easi-recharge";
import orderReducer from "@/redux/slices/order";

import { orderPortalApi } from "./services/order-portal";

const sentryReduxEnhancer = Sentry.createReduxEnhancer();

const store = configureStore({
  reducer: {
    order: orderReducer,
    easiRecharge: easiRechargeReducer,

    [orderPortalApi.reducerPath]: orderPortalApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(orderPortalApi.middleware),
  enhancers: (getDefaultEnhancers) => {
    return getDefaultEnhancers().concat(sentryReduxEnhancer);
  },
});

setupListeners(store.dispatch);

type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;

type RootState = ReturnType<typeof store.getState>;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
